import { render, staticRenderFns } from "./BoschArea.vue?vue&type=template&id=f65140d8&scoped=true"
import script from "./BoschArea.vue?vue&type=script&lang=js"
export * from "./BoschArea.vue?vue&type=script&lang=js"
import style0 from "./BoschArea.vue?vue&type=style&index=0&id=f65140d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65140d8",
  null
  
)

export default component.exports